import { getFileRequest } from 'src/utils/http';
import { mediasController } from './consts';

export const getMedia = async (mediaId, fileMIME) =>
  getFileRequest(`${mediasController}/${mediaId}`, fileMIME);
